<template>
  <div class="flex items-center">
    <vs-avatar :src="params.data.user.avatar ? `https://selfie.cash/avatar/${params.data.user.avatar}`
      : require('@/assets/images/avatar.png')" class="flex-shrink-0 mr-2" size="30px" />
    <div class="flex flex-col" style="line-height: normal;">
      <p style="color: black;">{{ params.data.user.firstname + ' ' + params.data.user.lastname }}</p>
      <p style="font-size: 12px;">{{ params.data.user.email }}</p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'CellRendererLink',
  computed: {
    url() {
      return '/engineer/engineer-view/' + this.params.data.id;

      // Below line will be for actual product
      // Currently it's commented due to demo purpose - Above url is for demo purpose
      // return "/apps/user/user-view/" + this.params.data.id
    }
  }
};
</script>
